

import fetch from 'node-fetch';
import { getJson, LogCategory, log } from './logger';

export default class RawApiCall {

    /* IN:
        {
        url: url
        body: body / undefined
        method: GET / POST / undefined
        headers: collection of headers  or undefined
        wantAnswerHeaders: array of answer header names to return or undefined
        }

        OUT:
        {
        status: status
        headers: collection of header values, based on wantAnswerHeaders
        body: body of answer (as text). If error during request, check status. body will be null
        json: the body, converted to json (if possible). Otherwise, {}
        jsonOk: true if body could be converted to json, false otherwise
        }
    * */
    static async apiCall(json) {
        var url = encodeURI(json.url) ;
        var req = {
            mode: "no-cors", cache: "no-cache", method: 'GET',
        };

        if ( json.method !== undefined)
            req.method = json.method;
        if ( json.headers !== undefined)
            req.headers = json.headers;
        else
            req.headers = {};
        if (json.clientIp !== undefined)
            req.headers["X-Forwarded-For"] = json.clientIp;

        if ( json.body !== undefined)
            req.body = JSON.stringify( json.body);

        var status = 500;
        var body = null;
        var headers = [];

        log(LogCategory.rawApiCallHeaders,"headers for " + url + " => " + JSON.stringify(req.headers));

        try {
            const response = await fetch(url, req);
            status = response.status;

            // read headers
            if ( json.wantAnswerHeaders !== undefined) {
                for ( var i in json.wantAnswerHeaders) {
                    var h = json.wantAnswerHeaders[i];
                    headers[h] = response.headers.get(h);
                }
            }
            body = await response.text();
        } catch (e) {
            log(LogCategory.error,"could not get url " + url + " " + e.message + "\r\n" + e.stack);
            body = "";
        }

        var resultJson = {};
        let jsonOk = true;
        try {
            if ( body != "")
                resultJson = JSON.parse(body);
        } catch(e) {
            resultJson = {};
            log(LogCategory.warn, "could not parse json for " + url);
            jsonOk = false;
        }

        log(LogCategory.rawApiCall,"raw api " + url + " " + (LogCategory.rawApiPostBody.log ? "body[" + req.body + "] " : "" ) + status);
        if ( LogCategory.rawApiPostBody.log) {
            // if we have json -> dump that. Otherwise, dump at most 1000 chars of the body
            let trimmedBody = body;
            if ( trimmedBody.length > 1000)
                trimmedBody = trimmedBody.substr(0, 1000);
            var stringifiedJson = getJson(resultJson);
            if ( stringifiedJson.length > 10)
                trimmedBody = stringifiedJson;

            log(LogCategory.rawApiCallAnswer,"raw api " + url + " [answer]: " + trimmedBody);
        }

        var result = { url: url, status: status, body: body, headers: headers, json: resultJson, jsonOk: jsonOk };
        //log(LogCategory.info,"api result=" + getJson(result, null, 4));
        return result;
    }

};



// WEBPACK FOOTER //
// ./src/api/rawApiCall.js